/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { CreatePaymentRequest } from '../models/CreatePaymentRequest';
import { PaymentDto } from '../models/PaymentDto';
import { ApiError, catchGenericError } from '../core/ApiError';
import { request as __request } from '../core/request';
import { OpenAPI } from '../core/OpenAPI';

export class PaymentService {

    /**
     * Start a payment and get details
     * @param requestBody
     * @result PaymentDto
     * @throws ApiError
     */
    public static async paymentControllerRegisterPayment(
        requestBody: CreatePaymentRequest,
    ): Promise<PaymentDto> {

        const result = await __request({
            method: 'post',
            path: `/api/payment/create`,
            body: requestBody,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Check transaction status
     * @param id
     * @result any
     * @throws ApiError
     */
    public static async paymentControllerCheckStatus(
        id: number,
    ): Promise<any> {

        const result = await __request({
            method: 'get',
            path: `/api/payment/${id}/status`,
            query: {
                'id': id,
            },
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get payments from user
     * @result PaymentDto
     * @throws ApiError
     */
    public static async paymentControllerGetPayments(): Promise<Array<PaymentDto>> {

        const result = await __request({
            method: 'get',
            path: `/api/payment/all`,
        });

        catchGenericError(result);

        return result.body;
    }

    /**
     * Get credits (Only for testing purposes)
     * @result any
     * @throws ApiError
     */
    public static async paymentControllerGetCredits(): Promise<any> {

        const result = await __request({
            method: 'post',
            path: `/api/payment/credits`,
        });

        catchGenericError(result);

        return result.body;
    }

}


// WEBPACK FOOTER //
// ./src/services/openapi/generated/services/PaymentService.ts